import '../css/team.css';
import nani from '../img/team_pics/nani_2.jpeg';
import akash from '../img/team_pics/akash_final.jpeg';
import kristy from '../img/team_pics/kristy_profile.jpeg';

const Team = () => {
    return (
        <div className='main-container'>
            <div className="main-wrapper">
                <section className="review-area pb-100 pt-40" id="mission">
                    <div className="container">
                        <div className="row justify-content-start align-items-center">
                            <div className="col-lg-6 video-left">
                                <br />
                                <header className='pt-120'>
                                    <h1 className="page-heading">Team</h1>
                                </header>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="video-sec-area pb-100 pt-40" id="about">
                    <div className="container">
                        <div className="row justify-content-start align-items-center">
                            <div className="col-lg-6 video-left">
                                <div className="team-pic-overlay">
                                    <img className="teams-pic" src={nani} alt="Nani" title="Nani" draggable="false" />
                                </div>
                                <br />
                                <h1>Pastor Nani</h1>
                                <p>
                                    Nani is a <b>bi-vocational leader</b>—serving as the lead pastor of Baptist Church Alkapoor and a senior software engineer by profession. With a rare combination of technological expertise and theological depth, he brings both precision and compassion to every sphere of his life. 
                                    <br/><br/>
                                    A graduate of IIT Guwahati in Computer Science and UBS Pune with a Master of Divinity (M.Div), Pastor Nani integrates his academic excellence with a deep commitment to spiritual growth and community transformation. His journey in ministry began in his youth through Youth Alive Ministries (YAM), Warangal, Telangana, where he actively contributed to Bible studies, skits, Sunday School, youth programs, and discipleship training. Today, he continues to serve as a board member of YAM, nurturing the next generation of leaders.
                                    <br/><br/>
                                    When not immersed in software development, Pastor Nani devotes his time and spiritual gifts to shepherding others—offering biblical teaching, personal counseling, and gospel-centered outreach. His sermons are known for their clarity, conviction, and relevance, often drawing from both Scripture and lived experience to inspire lasting change.
                                    <br/><br/>
                                    Driven by a passion to serve God wholeheartedly, Pastor Nani ensures that every member of his community feels seen, heard, and empowered. His leadership reflects a rare harmony of intellect and empathy, making a profound impact across both ministry and marketplace.
                                </p>
                            </div>

                        </div>
                    </div>
                </section>
                <section className="video-sec-area pb-100 pt-40" id="about">
                    <div className="container">
                        <div className="row justify-content-start align-items-center">
                            <div className="col-lg-6 video-left">
                                <div className="team-pic-overlay">
                                    <img className="teams-pic" src={kristy} alt="Kristy" title="Kristy" draggable="false" />
                                </div>
                                <br />
                                <h1>Kristy</h1>
                                <p>
                                    Designer
                                </p>
                            </div>

                        </div>
                    </div>
                </section>
                <section className="video-sec-area pb-100 pt-40" id="about">
                    <div className="container">
                        <div className="row justify-content-start align-items-center">
                            <div className="col-lg-6 video-left">
                                <div className="team-pic-overlay">
                                    <img className="teams-pic" src={akash} alt="Akash" title="Akash" draggable="false" />
                                </div>
                                <br />
                                <h1>Akash</h1>
                                <p>
                                    Tech/Media/Youth Volunteer/All-rounder
                                </p>
                            </div>

                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}
export default Team;